// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GrowthTracking.module.css */

.GrowthTrackingTab_dashboardContainer__hdEVv {
  background-color: #f1f2fb;
  min-height: auto;
  font-family: inherit;
   margin-bottom: 0;
  padding-bottom: 0;
}

.GrowthTrackingTab_sectionTitle__eNrhA {
  color: #364e69;
  font-weight: 600;
  font-size: 1.25rem;
  font-family: inherit;
}

.GrowthTrackingTab_kpiCard__3usJN {
  background: white;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  height: 140px; /* Fixed height: reduce this to shrink the card */
  padding: 0.75rem; /* Less padding = more compact */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start; /* or center if you want centered content */
}

.GrowthTrackingTab_kpiIcon__sP8sX {
  color: #83a4cf;
  width: 24px;
  height: 24px;
}

.GrowthTrackingTab_kpiValue__P3bEb {
  font-size: 1.5rem;
  font-weight: 700;
  color: #364e69;
  font-family: inherit;
}

.GrowthTrackingTab_kpiLabel__7UChc {
  font-size: 0.875rem;
  color: #6b7280;
  font-family: inherit;
}

.GrowthTrackingTab_up__eNI73::after {
  content: "↗";
  color: #10b981;
  margin-left: 4px;
}

.GrowthTrackingTab_down__Olby8::after {
  content: "↘";
  color: #ef4444;
  margin-left: 4px;
}

.GrowthTrackingTab_vehicleSelection__L8Pav {
  background: white;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.GrowthTrackingTab_vehicleIcon__v\\+obv {
  color: #83a4cf;
  width: 20px;
  height: 20px;
}

.GrowthTrackingTab_btnToggle__jb8SQ {
  background-color: #83a4cf;
  border: none;
  border-radius: 20px;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 8px 16px;
  margin: 0 2px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-family: inherit;
}

.GrowthTrackingTab_btnToggle__jb8SQ.GrowthTrackingTab_active__HCpMr {
  background-color: #364e69;
}

.GrowthTrackingTab_btnToggle__jb8SQ:hover {
  background-color: #6b8db5;
}

.GrowthTrackingTab_paramCard__DfMfy {
  background: white;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.GrowthTrackingTab_paramIcon__gJtt\\+ {
  color: #83a4cf;
  width: 20px;
  height: 20px;
}

.GrowthTrackingTab_paramTitle__IAn5r {
  font-size: 0.875rem;
  color: #364e69;
  font-weight: 500;
  font-family: inherit;
}

.GrowthTrackingTab_paramValue__tlf01 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #364e69;
  font-family: inherit;
}

.GrowthTrackingTab_paramSubtitle__TZ98b {
  font-size: 0.75rem;
  color: #9ca3af;
  font-family: inherit;
}


.GrowthTrackingTab_viewGraphBtn__wZrSz {
  color: #83a4cf;
  text-decoration: none;
  font-size: 0.75rem;
  font-weight: 500;
  font-family: inherit;
}

.GrowthTrackingTab_viewGraphBtn__wZrSz:hover {
  color: #6b8db5;
  text-decoration: underline;
}

.GrowthTrackingTab_chartContainer__sQo01 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  height: 300px;
}

.GrowthTrackingTab_downloadBtn__K-23H {
  color: #83a4cf;
  text-decoration: none;
  font-size: 0.875rem;
  font-family: inherit;
  border: none;
  background: transparent;
}

.GrowthTrackingTab_carbonInfo__6nS8X {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: inherit;
}

.GrowthTrackingTab_selectCustom__broF8 {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #364e69;
  background-color: white;
  padding: 8px 12px;
  font-family: inherit;
  width: 100%;
}

.GrowthTrackingTab_chartSvg__mJbyQ {
  /* Additional chart-specific styles if needed */
}
.GrowthTrackingTab_download-btn-wrapper__M3b6I {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px 0;
  align-items: right;
  position: absolute;
  
  margin-right: 20px;
}
.GrowthTrackingTab_download-btn-container__X1GQ8{
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/GrowthTrackingTab_bus/GrowthTrackingTab.module.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;GACnB,gBAAgB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;;EAEzC,aAAa,EAAE,iDAAiD;EAChE,gBAAgB,EAAE,gCAAgC;EAClD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAE,2CAA2C;AACtE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;;EAElB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb","sourcesContent":["/* GrowthTracking.module.css */\n\n.dashboardContainer {\n  background-color: #f1f2fb;\n  min-height: auto;\n  font-family: inherit;\n   margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.sectionTitle {\n  color: #364e69;\n  font-weight: 600;\n  font-size: 1.25rem;\n  font-family: inherit;\n}\n\n.kpiCard {\n  background: white;\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n\n  height: 140px; /* Fixed height: reduce this to shrink the card */\n  padding: 0.75rem; /* Less padding = more compact */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start; /* or center if you want centered content */\n}\n\n.kpiIcon {\n  color: #83a4cf;\n  width: 24px;\n  height: 24px;\n}\n\n.kpiValue {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #364e69;\n  font-family: inherit;\n}\n\n.kpiLabel {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-family: inherit;\n}\n\n.up::after {\n  content: \"↗\";\n  color: #10b981;\n  margin-left: 4px;\n}\n\n.down::after {\n  content: \"↘\";\n  color: #ef4444;\n  margin-left: 4px;\n}\n\n.vehicleSelection {\n  background: white;\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.vehicleIcon {\n  color: #83a4cf;\n  width: 20px;\n  height: 20px;\n}\n\n.btnToggle {\n  background-color: #83a4cf;\n  border: none;\n  border-radius: 20px;\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 8px 16px;\n  margin: 0 2px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-family: inherit;\n}\n\n.btnToggle.active {\n  background-color: #364e69;\n}\n\n.btnToggle:hover {\n  background-color: #6b8db5;\n}\n\n.paramCard {\n  background: white;\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.paramIcon {\n  color: #83a4cf;\n  width: 20px;\n  height: 20px;\n}\n\n.paramTitle {\n  font-size: 0.875rem;\n  color: #364e69;\n  font-weight: 500;\n  font-family: inherit;\n}\n\n.paramValue {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #364e69;\n  font-family: inherit;\n}\n\n.paramSubtitle {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  font-family: inherit;\n}\n\n\n.viewGraphBtn {\n  color: #83a4cf;\n  text-decoration: none;\n  font-size: 0.75rem;\n  font-weight: 500;\n  font-family: inherit;\n}\n\n.viewGraphBtn:hover {\n  color: #6b8db5;\n  text-decoration: underline;\n}\n\n.chartContainer {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  height: 300px;\n}\n\n.downloadBtn {\n  color: #83a4cf;\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: none;\n  background: transparent;\n}\n\n.carbonInfo {\n  font-size: 0.75rem;\n  color: #6b7280;\n  font-family: inherit;\n}\n\n.selectCustom {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  color: #364e69;\n  background-color: white;\n  padding: 8px 12px;\n  font-family: inherit;\n  width: 100%;\n}\n\n.chartSvg {\n  /* Additional chart-specific styles if needed */\n}\n.download-btn-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 20px 0;\n  align-items: right;\n  position: absolute;\n  \n  margin-right: 20px;\n}\n.download-btn-container{\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardContainer": `GrowthTrackingTab_dashboardContainer__hdEVv`,
	"sectionTitle": `GrowthTrackingTab_sectionTitle__eNrhA`,
	"kpiCard": `GrowthTrackingTab_kpiCard__3usJN`,
	"kpiIcon": `GrowthTrackingTab_kpiIcon__sP8sX`,
	"kpiValue": `GrowthTrackingTab_kpiValue__P3bEb`,
	"kpiLabel": `GrowthTrackingTab_kpiLabel__7UChc`,
	"up": `GrowthTrackingTab_up__eNI73`,
	"down": `GrowthTrackingTab_down__Olby8`,
	"vehicleSelection": `GrowthTrackingTab_vehicleSelection__L8Pav`,
	"vehicleIcon": `GrowthTrackingTab_vehicleIcon__v+obv`,
	"btnToggle": `GrowthTrackingTab_btnToggle__jb8SQ`,
	"active": `GrowthTrackingTab_active__HCpMr`,
	"paramCard": `GrowthTrackingTab_paramCard__DfMfy`,
	"paramIcon": `GrowthTrackingTab_paramIcon__gJtt+`,
	"paramTitle": `GrowthTrackingTab_paramTitle__IAn5r`,
	"paramValue": `GrowthTrackingTab_paramValue__tlf01`,
	"paramSubtitle": `GrowthTrackingTab_paramSubtitle__TZ98b`,
	"viewGraphBtn": `GrowthTrackingTab_viewGraphBtn__wZrSz`,
	"chartContainer": `GrowthTrackingTab_chartContainer__sQo01`,
	"downloadBtn": `GrowthTrackingTab_downloadBtn__K-23H`,
	"carbonInfo": `GrowthTrackingTab_carbonInfo__6nS8X`,
	"selectCustom": `GrowthTrackingTab_selectCustom__broF8`,
	"chartSvg": `GrowthTrackingTab_chartSvg__mJbyQ`,
	"download-btn-wrapper": `GrowthTrackingTab_download-btn-wrapper__M3b6I`,
	"download-btn-container": `GrowthTrackingTab_download-btn-container__X1GQ8`
};
export default ___CSS_LOADER_EXPORT___;
